import styles from "./ResizeablePanelHandle.module.scss";

export const ResizeablePanelHandle = (): JSX.Element => {
  return <div className={styles.ResizeablePanelHandle} />;
};
